module.exports = __webpack_public_path__ + "static/media/ubisoft_toronto_mentorship_2015.7ac8b5da.mp4";